/**
 * Copy for `/metal-resources/references/faq/`
 * (`src/pages/metal-resources/references/faq/index.tsx`), shared by both brands: SEO fields and
 * hero text. `FaqPageContent` is the page's site-search
 * entry, listed in `scripts/staticSearch.ts`. The `fr` and `es` SEO entries repeat the English
 * text, and every language's title says "Ryerson", on the STS build too.
 */
import { FAQHero } from "@components/FAQ/FAQ";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHead";
import { StaticPageContent } from "@components/Shared/model/StaticPageContent";

/** `MetaHead` content for the FAQ page, per language. */
export const FaqMetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Frequently Asked Questions - Ryerson",
		description: `How can we help you? Please see our most frequently asked questions for more information. Find answers for some of the most common customer service questions.`,
		url: `/metal-resources/references/faq`,
		company: true,
	},
	fr: {
		title: "Frequently Asked Questions - Ryerson",
		description: `How can we help you? Please see our most frequently asked questions for more information. Find answers for some of the most common customer service questions.`,
		url: `/metal-resources/references/faq`,
		company: true,
	},
	es: {
		title: "Frequently Asked Questions - Ryerson",
		description: `How can we help you? Please see our most frequently asked questions for more information. Find answers for some of the most common customer service questions.`,
		url: `/metal-resources/references/faq`,
		company: true,
	},
};

/** Hero and search-box copy for `src/components/FAQ/FAQ.tsx`, per language. */
export const FaqHeroContent: LanguageContent<FAQHero> = {
	en: {
		title: "Frequently Asked Questions",
		mobileTitle: "FAQ",
		searchPlaceholder: "Search the FAQs",
		description:
			"How can we help you? Please see our most frequently asked questions below for more information.",
	},
	fr: {
		title: "Questions fréquemment posées",
		mobileTitle: "FAQ",
		searchPlaceholder: "Rechercher dans la FAQ",
		description:
			"Comment pouvons-nous vous aider? Veuillez consulter nos questions les plus fréquemment posées ci-dessous pour plus d'informations.",
	},
	es: {
		title: "Preguntas más frecuentes",
		mobileTitle: "FAQ",
		searchPlaceholder: "Buscar las preguntas frecuentes",
		description:
			"Como podemos ayudarte? Consulte nuestras preguntas más frecuentes a continuación para obtener más información.",
	},
};

/** Site-search entry for the FAQ page; the questions themselves, from Contentful, are not in it. */
export const FaqPageContent: StaticPageContent = {
	meta: FaqMetaObject,
	content: [FaqHeroContent],
};
